.container {
  width: 37.5rem;

  legend {
    font-weight: inherit;
  }
}
